import React from 'react';

import classNames from 'classnames';

import { DocFileIcon } from '../../icons';

import { PreviewButtons } from './Buttons';
import { useStyles } from './Preview.styles';

interface PreviewDocxProps {
  shape: 'auto' | 'square';
  onClickDownload?: () => Promise<
    Blob | { file: Promise<Blob>; filename?: string }
  >;
  withCollapsableFooter?: boolean;
}

/**
 * Компонент для предварительного просмотра файла формата DOCX.
 * @param {string} shape - Форма компонента ('auto' или 'square').
 * @param {Function} [onClickDownload] - Опциональная функция, вызываемая при нажатии кнопки загрузки файла.
 * @param {boolean} [withCollapsableFooter] - Опциональный флаг, указывающий наличие сворачиваемого нижнего колонтитула.
 * @returns {ReactElement} Возвращает элемент React с предварительным просмотром файла DOCX.
 */

export const PreviewDocx = ({
  shape,
  onClickDownload,
  withCollapsableFooter,
}: PreviewDocxProps) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(
        classes.root,
        classes.collapseWrapper,
        classes.previewDocx,
      )}
    >
      {shape === 'square' && <div className={classes.square} />}
      <div className={classes.docIcon}>
        <DocFileIcon />
      </div>
      {onClickDownload && (
        <PreviewButtons
          onClickDownload={onClickDownload}
          withCollapsableFooter={withCollapsableFooter}
        />
      )}
    </div>
  );
};
